// 登录、重置密码、注册
import request from '@/utils/request';
import { encryptString } from '@/utils';

const serverUrl = process.env.VUE_APP_BASE_API;
// const paymentUrl = process.env.VUE_APP_PAYMENT_BASE_API;

const member = {
  // 获取用户卡列表
  getAccountList(data) {
    return request({
      // url: `${serverUrl}/visa/latam/card/list`,
      url: `${serverUrl}/visa/latam/card/cardListV2`,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      data,
    });
  },

  // 用户上传头像
  // uploadHeadImg(data) {
  //   return request({
  //     url: `${serverUrl}/visa/latam/user/uploadHeadImg`,
  //     method: 'POST',
  //     headers: {
  //       'Content-Type': 'multipart/form-data',
  //     },
  //     data,
  //   });
  // },

  // 用户更新上传信息 + 图片上传
  updateUser(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/updateUser`,
      method: 'POST',
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      data,
    });
  },

  // 获取会籍卡PDF
  getMemberShipPdf(data) {
    return request({
      url: `${serverUrl}/visa/latam/membership/getMemberShipPdf`,
      method: 'POST',
      responseType: 'blob',
      data,
    });
  },

  // 发送会籍卡PDF至Email
  sendMemberCardEmail(data) {
    return request({
      url: `${serverUrl}/visa/latam/membership/sendMemberShipEmail`,
      method: 'POST',
      data,
    });
  },

  // 获取机场休息室列表和餐厅权益列表
  getLoungeList(data) {
    return request({
      url: `${serverUrl}/visa/latam/web/benefit/list?type=${data.type}&lang=${data.lang}`,
      method: 'GET',
    });
  },

  // 绑卡（信用卡、龙腾卡)
  bindVisaCard(data) {
    return request({
      url: `${serverUrl}/visa/card/vces/ingenico/bindCardV2`,
      method: 'POST',
      data,
    });
  },

  // 更新Visa Card
  updateVisaCard(data) {
    return request({
      url: `${serverUrl}/visa/card/vces/ingenico/v2/replace`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 修改默认的龙腾卡
  setDefaultCard(data) {
    return request({
      url: `${serverUrl}/visa/latam/card/changeDefault`,
      method: 'POST',
      data,
    });
  },

  // 修改登录密码
  async changePassword(data) {
    const oldPassword = await encryptString(data.oldPassword);
    const newPassword = await encryptString(data.newPassword);
    return request({
      url: `${serverUrl}/visa/latam/user/changePassword`,
      method: 'POST',
      data: { ...data, oldPassword, newPassword },
    });
  },

  getUserInfo(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/getUserInfo`,
      method: 'POST',
      data,
    });
  },

  // 根据入口的类型获取联系方式
  getByType(data) {
    return request({
      url: `${serverUrl}/visa/latam/contact/getByType`,
      method: 'POST',
      data,
    });
  },

  // 切卡校验
  creditCardValid(data) {
    return request({
      url: `${serverUrl}/visa/latam/card/ingenico/isCreditValid`,
      method: 'POST',
      data,
    });
  },

  // 检查卡是否可以delink
  checkDelink(data) {
    return request({
      url: `${serverUrl}/visa/latam/card/checkDelink`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // membership delink
  delinkCard(data) {
    return request({
      url: `${serverUrl}/visa/latam/card/delink`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default member;
